import React, { useState } from "react";
import Header from "./Header";

function AIAgent() {
  const [query, setQuery] = useState("");
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState(""); // For Header component

  const handleAnalyze = async () => {
    if (!query.trim()) {
      setError("Please enter a query");
      return;
    }

    setLoading(true);
    setError(null);
    setAnalysis(null);

    try {
      // TODO: 调用后端 API 进行分析
      // 这里先使用模拟数据
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      setAnalysis({
        query: query,
        result: "This is a placeholder analysis result. Please implement the backend API endpoint to get real analysis.",
        timestamp: new Date().toISOString()
      });
    } catch (err) {
      setError("Failed to analyze. Please try again later.");
      console.error("Error analyzing:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleAnalyze();
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header filter={filter} setFilter={setFilter} />
      
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">AI Agent Analysis</h1>
          <p className="text-gray-600 mb-6">
            Analyze DeFi protocols, risks, and opportunities using AI-powered insights.
          </p>

          <div className="space-y-4">
            <div>
              <label htmlFor="query" className="block text-sm font-medium text-gray-700 mb-2">
                Enter your query
              </label>
              <textarea
                id="query"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="e.g., Analyze the risks of Aave protocol, Compare Uniswap V3 and V2, What are the best yield farming opportunities?"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                rows={4}
              />
            </div>

            <button
              onClick={handleAnalyze}
              disabled={loading || !query.trim()}
              className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-semibold"
            >
              {loading ? "Analyzing..." : "Analyze"}
            </button>

            {error && (
              <div className="rounded-md bg-red-50 p-4 text-sm text-red-600">
                {error}
              </div>
            )}
          </div>
        </div>

        {analysis && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-900">Analysis Result</h2>
              <span className="text-xs text-gray-500">
                {new Date(analysis.timestamp).toLocaleString()}
              </span>
            </div>
            
            <div className="mb-4">
              <p className="text-sm font-medium text-gray-500 mb-1">Query:</p>
              <p className="text-gray-700">{analysis.query}</p>
            </div>

            <div className="border-t border-gray-200 pt-4">
              <p className="text-sm font-medium text-gray-500 mb-2">Analysis:</p>
              <div className="prose prose-sm max-w-none text-gray-700 whitespace-pre-wrap">
                {analysis.result}
              </div>
            </div>
          </div>
        )}

        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">
            <strong>Note:</strong> This feature requires backend API implementation. 
            Please connect to your AI analysis service endpoint.
          </p>
        </div>
      </main>
    </div>
  );
}

export default AIAgent;

